import {
  FETCH_STATISTICS_REQUESTED,
  FETCH_STATISTICS_SUCCESS,
  FETCH_STATISTICS_FAILURE,
} from 'constants/actions'

import { fetchStatistics as fetchStatisticsRequest } from 'api/requests'

export const getStatistics = () => async (dispatch) => {
  dispatch({ type: FETCH_STATISTICS_REQUESTED })

  try {
    const response = await fetchStatisticsRequest()

    if (response.data) {
      dispatch({
        type: FETCH_STATISTICS_SUCCESS,
        data: response.data,
      })
    }
  } catch (error) {
    dispatch({
      type: FETCH_STATISTICS_FAILURE,
      data: { message: error.response?.data?.error || 'Failed to load statistics.' },
    })
  }
}
